import { COLOR_PRIMARY } from ".";

export const themeConfig ={
        components: {
          Layout: {
            bodyBg: "#FFFFFF",
            headerBg: "#FFFFFF",
            triggerBg: "#FFFFFF",
          },
          Menu: {
            itemSelectedColor: "white",
            colorItem: "white",
            itemSelectedBg: COLOR_PRIMARY,
            itemColor: "#53545C",
            itemSelectedColor: "white",
          },
        },
        token: {
          colorPrimary: COLOR_PRIMARY,
          colorBgContainer: "#ffffff",
          colorBgLayout: "#ffffff",
        },
      }